export default function RatingStar({ fill = "transparent", className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16.876"
      viewBox="0 0 18 16.876"
    >
      <path
        id="Path_6"
        data-name="Path 6"
        d="M4.065,17.935a.6.6,0,0,1-.84-.666l.934-5.322L.2,8.172A.626.626,0,0,1,.515,7.1l5.51-.783L8.482,1.453a.578.578,0,0,1,1.043,0l2.457,4.868,5.51.783a.626.626,0,0,1,.319,1.069l-3.964,3.776.934,5.322a.6.6,0,0,1-.84.666L9,15.4,4.064,17.935Z"
        transform="translate(-0.003 -1.124)"
        fill={fill}
        className={className}
      />
    </svg>
  );
}
